import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Instagram, Twitter, Linkedin } from "lucide-react";
import { IMAGES } from "../mock";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Racing Management", to: "/racing-management" },
  { label: "The Team", to: "/team" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "News", to: "/blog" },
  { label: "Videos", to: "/videos" },
  { label: "Contact", to: "#contact" },
];

const SocialIcons = ({ className = "" }) => (
  <div className={`flex items-center gap-5 ${className}`}>
    <a href="https://www.instagram.com/global_equine_group/" target="_blank" rel="noreferrer" aria-label="Instagram"
      className="text-[#29abe2] hover:text-white transition-colors duration-300">
      <Instagram size={20} strokeWidth={1.8} />
    </a>
    <a href="https://x.com/globalequine" target="_blank" rel="noreferrer" aria-label="X (formerly Twitter)"
      className="text-[#29abe2] hover:text-white transition-colors duration-300">
      <Twitter size={20} strokeWidth={1.8} />
    </a>
    <a href="https://www.linkedin.com/company/global-equine-group-ltd/" target="_blank" rel="noreferrer" aria-label="LinkedIn"
      className="text-[#29abe2] hover:text-white transition-colors duration-300">
      <Linkedin size={20} strokeWidth={1.8} />
    </a>
  </div>
);

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <>
      <header
        className={`gee-header fixed top-0 left-0 right-0 z-[100] ${scrolled ? "gee-header--scrolled" : ""}`}
        style={{ backgroundColor: "#0f2438" }}
        data-testid="site-header"
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 flex items-center justify-between"
          style={{ height: scrolled ? 72 : 96, transition: "height 0.35s ease" }}>
          <Link to="/" className="flex items-center" data-testid="header-logo">
            <img src={IMAGES.logo} alt="Global Equine Group" width="345" height="66" fetchPriority="high" className="h-10 md:h-12 w-auto" />
          </Link>
          <div className="flex items-center gap-8">
            <SocialIcons className="hidden md:flex" />
            <button
              className={`gee-burger ${menuOpen ? "open" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              data-testid="menu-toggle"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>

      <div className={`gee-menu ${menuOpen ? "open" : ""}`} data-testid="fullscreen-menu">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-32 pb-16 min-h-full flex flex-col">
          <nav className="flex flex-col gap-2 md:gap-4">
            {NAV_LINKS.map((link, i) => (
              <Link
                key={link.label}
                to={link.to}
                className="gee-menu-link"
                style={{ transitionDelay: menuOpen ? `${0.15 + i * 0.08}s` : "0s" }}
                onClick={() => setMenuOpen(false)}
                data-testid={`menu-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="gee-menu-num">0{i + 1}</span>
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="mt-auto pt-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <div>
              <p className="gee-kicker mb-3">Get In Touch</p>
              <a href="mailto:info@globalequinegroup.com"
                className="text-white text-lg hover:text-[#29abe2] transition-colors">
                info@globalequinegroup.com
              </a>
              <p className="text-[#7d94a6] mt-2 text-sm">Newmarket, Suffolk, England</p>
            </div>
            <SocialIcons />
          </div>
        </div>
      </div>
    </>
  );
}
